
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/topBar/dashboardShortcut/dashboardShortcut.scss.css.virtualfile';
        module.exports = {"dashboard-shortcut-wrapper":"_dashboard-shortcut-wrapper_1mr2v_1","dashboardShortcutWrapper":"_dashboard-shortcut-wrapper_1mr2v_1"};